import { translation } from 'utilsHelper.js';

export const CHANGE_DATE_BY_TYPE = 'CHANGE_BONUS_DATE_BY_TYPE';
export const FETCH_BONUS_LIST = 'FETCH_BONUS_LIST';
export const FETCH_CREDIT_BONUS_LIST = 'FETCH_CREDIT_BONUS_LIST';
export const SET_CURRENT_PAGE = 'SET_BONUS_CURRENT_PAGE';
export const CHANGE_ACTIVE_TAB = 'CHANGE_BONUS_ACTIVE_TAB';
export const FETCH_REGISTRATION_OFFERS = 'FETCH_REGISTRATION_OFFERS';

const setCurrentPage = (currentPage, activeTab) => {
  return {
    type: SET_CURRENT_PAGE,
    payload: { currentPage, activeTab },
  };
};

const changeActiveTab = (activeTab) => {
  return {
    type: CHANGE_ACTIVE_TAB,
    payload: {
      activeTab,
    },
  };
};

const changeDateByType = (dateType, date) => {
  return {
    type: CHANGE_DATE_BY_TYPE,
    payload: {
      dateType,
      date,
    },
  };
};

const fetchBonusListByFilter = (config = {}) => {
  return async (dispatch, getState, { AccountBonusApi }) => {
    dispatch(fetchBonusListPending());

    try {
      const {
        AccountBonus: { activeTab: _activeTab, limit, startDate, endDate, bonus },
      } = getState();
      const activeTab = config.activeTab || _activeTab;
      const { currentPage } = bonus[activeTab];
      const initialConfig = { activeTab, currentPage, limit, startDate, endDate };

      const { data: _data } = await AccountBonusApi.getBonusListByFilter({
        ...initialConfig,
        ...config,
      });
      let data = _data[activeTab];
      const isNextPageAvailable = data?.length > limit;
      if (isNextPageAvailable) data = data.slice(0, limit);

      dispatch(
        fetchBonusListSuccess({
          data,
          activeTab,
          isNextPageAvailable,
          keepPendingStatus: config?.keepPendingStatus ?? false,
        })
      );
      return { data, isNextPageAvailable };
    } catch (error) {
      dispatch(fetchBonusListFailure(error));
      throw error;
    }
  };
};

const fetchAllBonus = () => {
  return async (dispatch, getState) => {
    dispatch(fetchBonusListPending());

    try {
      const tabs = ['active', 'history', 'queue'];
      await Promise.all(
        tabs.map((tab) => {
          return dispatch(fetchBonusListByFilter({ activeTab: tab, keepPendingStatus: true }));
        })
      );
      dispatch(fetchBonusListFulfilled());
    } catch (error) {
      dispatch(fetchBonusListFailure(error));
      throw error;
    }
  };
};

const fetchBonusListFulfilled = () => {
  return {
    type: `${FETCH_BONUS_LIST}_FULFILLED`,
  };
};

const fetchBonusListSuccess = ({ data, activeTab, isNextPageAvailable, keepPendingStatus }) => {
  return {
    type: `${FETCH_BONUS_LIST}_SUCCESS`,
    payload: {
      data,
      activeTab,
      isNextPageAvailable,
      keepPendingStatus,
    },
  };
};

const fetchBonusListPending = () => {
  return {
    type: `${FETCH_BONUS_LIST}_PENDING`,
  };
};

const fetchBonusListFailure = (error) => {
  return {
    type: `${FETCH_BONUS_LIST}_FAILURE`,
    payload: { error },
  };
};

const fetchRegistrationOffersSuccess = (data) => {
  return {
    type: `${FETCH_REGISTRATION_OFFERS}_SUCCESS`,
    payload: { data },
  };
};

const fetchRegistrationOffersFailure = (error) => {
  return {
    type: `${FETCH_REGISTRATION_OFFERS}_FAILURE`,
    payload: { error },
  };
};

const fetchRegistrationOffersPending = () => {
  return {
    type: `${FETCH_REGISTRATION_OFFERS}_PENDING`,
  };
};

const fetchRegistrationOffers = () => {
  return async (dispatch, getState, { AccountBonusApi }) => {
    dispatch(fetchRegistrationOffersPending());
    try {
      let { code, data } = await AccountBonusApi.getRegistrationOffers();
      if (code !== 200) throw new Error(translation(`accountBonus_error${code}`));

      dispatch(fetchRegistrationOffersSuccess(data));

      return data;
    } catch ({ message }) {
      dispatch(fetchRegistrationOffersFailure(message));
      return {};
    }
  };
};

const fetchCreditBonusListByFilter = (config = {}) => {
  return async (dispatch, getState, { AccountBonusApi }) => {
    dispatch(fetchCreditBonusListPending());

    try {
      const {
        AccountBonus: { activeTab: _activeTab, limit, startDate, endDate, bonus },
      } = getState();
      const activeTab = config.activeTab || _activeTab;
      const { currentPage } = bonus[activeTab];
      const initialConfig = { activeTab, currentPage, limit, startDate, endDate };

      const { data: _data } = await AccountBonusApi.getCreditBonusListByFilter({
        ...initialConfig,
        ...config,
      });
      let data = _data[activeTab];
      const isNextPageAvailable = data?.length > limit;
      if (isNextPageAvailable) data = data.slice(0, limit);

      dispatch(
        fetchCreditBonusListSuccess({
          data,
          activeTab,
          isNextPageAvailable,
          keepPendingStatus: config?.keepPendingStatus ?? false,
        })
      );
    } catch (error) {
      dispatch(fetchCreditBonusListFailure(error));
      throw error;
    }
  };
};

const fetchCreditBonusListFulfilled = () => {
  return {
    type: `${FETCH_CREDIT_BONUS_LIST}_FULFILLED`,
  };
};

const fetchCreditBonusListSuccess = ({
  data,
  activeTab,
  isNextPageAvailable,
  keepPendingStatus,
}) => {
  return {
    type: `${FETCH_CREDIT_BONUS_LIST}_SUCCESS`,
    payload: {
      data,
      activeTab,
      isNextPageAvailable,
      keepPendingStatus,
    },
  };
};

const fetchCreditBonusListPending = () => {
  return {
    type: `${FETCH_CREDIT_BONUS_LIST}_PENDING`,
  };
};

const fetchCreditBonusListFailure = (error) => {
  return {
    type: `${FETCH_CREDIT_BONUS_LIST}_FAILURE`,
    payload: { error },
  };
};

const manageCreditBonus = (status, offerId) => {
  return async (dispatch, getState, { AccountBonusApi }) => {
    try {
      const {
        code,
        data,
        messageKey,
        description = 'undefined_error',
      } = await AccountBonusApi.manageCreditBonus(status, offerId);
      if (!data) {
        throw { message: `error_${messageKey ? messageKey : code}`, description: description };
      }
      await dispatch(fetchAllCreditBonus());
      return data;
    } catch (error) {
      throw `${'message' in error ? error['message'] : `error_${error.code}`}`;
    }
  };
};

const fetchAllCreditBonus = () => {
  return async (dispatch, getState) => {
    dispatch(fetchCreditBonusListPending());

    try {
      const tabs = ['active', 'history', 'queue'];
      await Promise.all(
        tabs.map((tab) => {
          return dispatch(
            fetchCreditBonusListByFilter({ activeTab: tab, keepPendingStatus: true })
          );
        })
      );
      dispatch(fetchCreditBonusListFulfilled());
    } catch (error) {
      dispatch(fetchCreditBonusListFailure(error));
      throw error;
    }
  };
};

const manageBonus = (status, offerId) => {
  return async (dispatch, getState, { AccountBonusApi }) => {
    try {
      const {
        code,
        data,
        messageKey,
        description = 'undefined_error',
      } = await AccountBonusApi.manageBonus(status, offerId);
      if (!data) {
        //obsługa błędów z 500 / na ten moment backend może zwrócić nam jedynie 500 + description/
        switch (description) {
          case (description.match(new RegExp('You have active bonus already!')) || {}).input:
            throw { message: 'error_You have active bonus already!' };
          case (
            description.match(new RegExp('Cannot cancel bonus, player have bets in play.')) || {}
          ).input:
            throw { message: 'error_Cannot cancel bonus, player have bets in play' };
          default:
            throw { message: `error_${messageKey ? messageKey : code}` };
        }
      }
      await dispatch(fetchAllBonus());
      return data;
    } catch (error) {
      throw `${'message' in error ? error['message'] : `error_${error.code}`}`;
    }
  };
};

export {
  changeDateByType,
  changeActiveTab,
  fetchBonusListByFilter,
  setCurrentPage,
  fetchBonusListPending,
  fetchBonusListFulfilled,
  fetchBonusListFailure,
  manageBonus,
  fetchRegistrationOffers,
  fetchCreditBonusListByFilter,
  fetchCreditBonusListPending,
  fetchCreditBonusListFulfilled,
  fetchCreditBonusListFailure,
  manageCreditBonus,
};
